import {
  accreditedDebtRelief,
  base44Logo,
  emergentLogo,
  freedomDebtRelief,
  nationalDebtRelief,
  rorkLogo,
  unitedSettlement,
} from "@/images";
import {
  FaBook,
  FaRobot,
  FaCode,
  FaCogs,
  FaDollarSign,
  FaCheckCircle,
  FaBalanceScale,
  FaExchangeAlt,
  FaQuestionCircle,
  FaClipboardCheck,
} from "react-icons/fa";

const NAV_MENU_DATA = [
  {
    title: "Trending",
    subMenu: [
      {
        title: "TRENDING",
        subMenuArr: [
          {
            title: "Best Pet Insurance Companies",
          },
          {
            title: "Best Tax Relief Companies",
          },
          {
            title: "Best Pest Control Companies",
          },
          {
            title: "Best Gold IRA Companies",
          },
          {
            title: "Solar Panel Cost",
          },
          {
            title: "Safest US States",
          },
          {
            title: "Most Expensive Cities",
          },
        ],
        viewAll: "View All Topics",
      },
    ],
  },
  {
    title: "Buyer Guides",
    subMenu: [
      {
        title: "AUTO",
        subMenuArr: [
          {
            title: "Best Extended Car Warranties",
          },
          {
            title: "Best Car Shipping",
          },
        ],
        viewAll: "View all Auto",
      },
      {
        title: "HOME",
        subMenuArr: [
          {
            title: "Best Home Warranties",
          },
          {
            title: "Best Solar Companies",
          },
          {
            title: "Best Home Security Systems",
          },
        ],
        viewAll: "View all Home",
      },
      {
        title: "Finance",
        subMenuArr: [
          {
            title: "Best Personal Loans",
          },
          {
            title: "Best Mortgage Lenders",
          },
          {
            title: "Best HELOC Lenders",
          },
          {
            title: "Best Gold Dealers",
          },
          {
            title: "Best Debt Settlement",
          },
        ],
        viewAll: "View all Finance",
      },
      {
        title: "Senior",
        subMenuArr: [
          {
            title: "Best Walk-in Tubs",
          },
          {
            title: "Best Walk-in Showers",
          },
          {
            title: "Best Medical Alert Systems",
          },
          {
            title: "Best Stair Lifts",
          },
          {
            title: "Best Reverse Mortgages",
          },
        ],
        viewAll: "View all Senior",
      },
    ],
  },
  {
    title: "Customer Reviews",
    subMenu: [
      {
        title: "AUTO",
        subMenuArr: [
          {
            title: "Endurance Warranty Reviews",
          },
          {
            title: "CarShield Reviews",
          },
          {
            title: "CARCHEX Reviews",
          },
        ],
        viewAll: "View all Auto",
      },
      {
        title: "HOME",
        subMenuArr: [
          {
            title: "Sunrun Reviews",
          },
          {
            title: "American Home Shield Reviews",
          },
          {
            title: "Choice Home Warranty Reviews",
          },
          {
            title: "ADT Reviews",
          },
          {
            title: "Vivint Smart Home Reviews",
          },
        ],
        viewAll: "View all Home",
      },
      {
        title: "Finance",
        subMenuArr: [
          {
            title: "Rocket Mortgage Reviews",
          },
          {
            title: "Quicken Loans Reviews",
          },
          {
            title: "New American Funding Reviews",
          },
          {
            title: "Patriot Gold Group Reviews",
          },
          {
            title: "AmeriSave Mortgage Reviews",
          },
        ],
        viewAll: "View all Finance",
      },
      {
        title: "Senior",
        subMenuArr: [
          {
            title: "Safe Step Walk-in Tubs Reviews",
          },
          {
            title: "American Standard Walk-in Baths Reviews",
          },
          {
            title: "ADT Medical Alert Reviews",
          },
          {
            title: "Medical Guardian Reviews",
          },
          {
            title: "Best Reverse Mortgages",
          },
        ],
        viewAll: "View all Senior",
      },
    ],
  },
  {
    title: "News",
    subMenu: [],
  },
];

const RESPONSIVE_NAV_MENU_DATA = [
  {
    title: "Best AI Web/App Builders",
    subMenu: [
      {
        subMenuArr: [
          {
            title: "Overview",
            href: "/#top-pick",
          },
          {
            title: "Company Profiles",
            href: "/#companies-profile",
          },
          {
            title: "Buyers Guide",
            href: "/#guide",
          },
          {
            title: "Reviews",
            href: "/#reviews",
          },
        ],
      },
    ],
  },
  {
    title: "Tutorials",
    href: "/tutorials",
  },
  {
    title: "About",
    href: "/about",
  },
  {
    title: "Login",
    href: "/account",
  },
  {
    title: "Careers",
    href: "/careers",
  },
  {
    title: "Terms of Use",
    href: "/terms-of-use",
  },
  {
    title: "Ask a Question",
    href: "/contact",
  },
  {
    title: "Contact Us",
    href: "/contact",
  },
  {
    title: "Privacy Policy",
    href: "/privacy-policy",
  },
];

const TABLE_DATA = [
  {
    company: nationalDebtRelief,
    name: "Lovable",
    review: 4.9,
    totalReviews: "56,847 reviews",
    pickFor: "Best overall",
    activeUsers: "2.3M monthly",
    startingPrice: "Free ($0/mo)",
    appsCreated: "500,000+",
    yearFounded: "2023",
    isVerified: true,
  },
  {
    company: base44Logo,
    name: "Base44",
    review: 4.8,
    totalReviews: "12,450 reviews",
    pickFor: "Rapid prototyping",
    activeUsers: "250K monthly",
    startingPrice: "Free ($0/mo)",
    appsCreated: "100,000+",
    yearFounded: "2024",
    isVerified: true,
  },
  {
    company: rorkLogo,
    name: "Rork",
    review: 4.8,
    totalReviews: "3,200 reviews",
    pickFor: "Mobile apps",
    activeUsers: "50K+ monthly",
    startingPrice: "$20/mo",
    appsCreated: "25,000+",
    yearFounded: "2024",
    isVerified: true,
  },
  {
    company: emergentLogo,
    name: "Emergent",
    review: 4.5,
    totalReviews: "5,000+ reviews",
    pickFor: "Autonomous development",
    activeUsers: "700K+ monthly",
    startingPrice: "Free ($0/mo)",
    appsCreated: "200,000+",
    yearFounded: "2024",
    isVerified: true,
  },
];

// Centralized affiliate links
const LOVABLE_AFFILIATE_LINK = "https://lovable.dev?via=beaiready";
const RORK_AFFILIATE_LINK = "https://rork.com/?ref=beaiready";
const EMERGENT_AFFILIATE_LINK = "https://app.emergent.sh/?via=beaiready";

const COMPANY_REVIEW_DATA = [
  {
    id: "lovable",
    company: nationalDebtRelief,
    image: nationalDebtRelief,
    tagName: "Fastest-Growing AI Development Platform",
    name: "Lovable",
    isVerified: true,
    review: 4.9,
    totalReviews: "56,907",
    activeUsers: "2.3M monthly",
    startingPrice: "Free ($0/mo)",
    appsCreated: "500,000+",
    yearFounded: 2023,
    isGetStarted: true,
    affiliateLink: LOVABLE_AFFILIATE_LINK,
    webDomain: "lovable",
    description:
      "AI-powered app development platform that transforms natural language into full-stack web applications. Generates production-ready code using React, Tailwind CSS, and Vite. Free plan with 5 daily credits, Pro plan at $25/month. Over 2.3 million monthly active users. SOC 2 Type 2 and ISO 27001 certified.",
  },
  {
    id: "base44",
    company: base44Logo,
    image: base44Logo,
    tagName: "Acquired by Wix for $80M",
    name: "Base44",
    isVerified: true,
    review: 4.8,
    totalReviews: "12,450",
    activeUsers: "250K monthly",
    startingPrice: "Free ($0/mo)",
    appsCreated: "100,000+",
    yearFounded: 2024,
    isGetStarted: true,
    affiliateLink: "https://base44.pxf.io/c/6641249/2049275/25619?trafcat=base",
    webDomain: "base44.com",
    description:
      "AI-powered app builder that transforms natural language into functional web and mobile applications. Built-in hosting with instant deployment. Includes database, AI, email, authentication, and analytics. Acquired by Wix for $80M in June 2025.",
  },
  {
    id: "rork",
    company: rorkLogo,
    image: rorkLogo,
    tagName: "Best for Mobile App Development",
    name: "Rork",
    isVerified: true,
    review: 4.8,
    totalReviews: "3,200",
    activeUsers: "50K+ monthly",
    startingPrice: "$20/mo",
    appsCreated: "25,000+",
    yearFounded: 2024,
    isGetStarted: true,
    affiliateLink: RORK_AFFILIATE_LINK,
    webDomain: "rork.com",
    description:
      "AI-powered mobile app builder that creates native iOS and Android apps from text prompts using React Native. Founded by Daniel Dhawan and Levan Kvirkveliia in 2024. Build complete cross-platform apps with authentication, navigation, and dashboards in minutes.",
  },
  {
    id: "emergent",
    coupon: { amount: "5% off on all payments", value: "BEAIREADY" },
    company: emergentLogo,
    image: emergentLogo,
    tagName: "#1 on OpenAI's SWE-Bench",
    name: "Emergent",
    isVerified: true,
    review: 4.7,
    totalReviews: "5,000+",
    activeUsers: "700K+ monthly",
    startingPrice: "Free ($0/mo)",
    appsCreated: "200,000+",
    yearFounded: 2024,
    isGetStarted: true,
    affiliateLink: EMERGENT_AFFILIATE_LINK,
    webDomain: "emergent.sh",
    description:
      "AI-powered vibe coding platform that builds, tests, and ships complete applications from natural language. Achieved #1 ranking on OpenAI's SWE-Bench. Backed by Y Combinator and raised $23M Series A led by Lightspeed. Founded by veterans from Google, Amazon, and Dropbox.",
  },
];

const DEBT_SETTLEMENT_SIDEBAR_DATA = [
  { id: "guide", title: "Buyer's guide", icon: FaBook },
  { id: "definition", title: "What are AI builders?", icon: FaRobot },
  { id: "what-can-it-develop", title: "What can it develop?", icon: FaCode },
  { id: "how-it-works", title: "How they work", icon: FaCogs },
  { id: "cost", title: "Pricing", icon: FaDollarSign },
  { id: "how-to-choose", title: "How to choose", icon: FaCheckCircle },
  { id: "pros-cons", title: "Pros and cons", icon: FaBalanceScale },
  { id: "alternatives", title: "Alternatives", icon: FaExchangeAlt },
  { id: "faq", title: "FAQ", icon: FaQuestionCircle },
  { id: "methodology", title: "Methodology", icon: FaClipboardCheck },
];

export {
  NAV_MENU_DATA,
  TABLE_DATA,
  DEBT_SETTLEMENT_SIDEBAR_DATA,
  COMPANY_REVIEW_DATA,
  RESPONSIVE_NAV_MENU_DATA,
  LOVABLE_AFFILIATE_LINK,
  RORK_AFFILIATE_LINK,
  EMERGENT_AFFILIATE_LINK,
};
